import React from 'react';
import {Card, Col, Row, Spin, Timeline} from 'antd';

import {messageType, showMessages} from '../../helpers/message';
import {BookingHistoryCardParams} from '../../types/bookingTypes';
import {BaseError} from '../../types/apiTypes';
import {useBookingDeploymentHistory} from '../../hooks/useBookingDeploymentHistory';

import './BookingHistoryCard.less'

const BookingHistoryCard = ({bookingID}: BookingHistoryCardParams) => {

    const {result, isLoading, error}  = useBookingDeploymentHistory(bookingID);

    React.useEffect(() => {
        if (error) {
            showMessages((error as BaseError).data?.message, messageType.error);
        }
    }, [error]);

    return (
        <Row gutter={{sm: 16}}>
            <Col xs={24} md={12}>
                <Spin spinning={isLoading}>
                    <Card title="Booking History" className="booking-history-card">
                        <Timeline mode={"left"} className="booking-history-timeline" items={result} />
                    </Card>
                </Spin>
            </Col>
        </Row>
    );
};

export default BookingHistoryCard;
